import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Label from 'components/Label';

import Styles from './Dropdown.module.scss';

export const Dropdown = ({
  field,
  name,
  placeholder,
  label,
  onChange = () => {},
  children,
  error,
  additionalControl,
  className
}) => (
  <div className={classnames(Styles['dropdown-container'], { [className]: className })}>
    {label && (
      <Label name={name} error={error}>
        {label}
      </Label>
    )}
    <div className={Styles['dropdown-component']}>
      <select
        id={name}
        className={classnames(Styles['dropdown'], {
          [Styles['error']]: error
        })}
        placeholder={placeholder}
        onChange={onChange}
        {...field}
        value={field && field.value ? field.value : ''}
      >
        <option value=""></option>
        {children}
      </select>
      {!!additionalControl && additionalControl}
    </div>
  </div>
);

Dropdown.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  children: PropTypes.any,
  field: PropTypes.object,
  error: PropTypes.string,
  additionalControl: PropTypes.any
};

export default Dropdown;
